import type { RollbackCommandData } from '@festina/legalentity-general-types/legalentity'

import { useHook } from '../../lenteHooks'
import type { CommandDataFormProps } from '../commandActions/CommandDataFormAndSimulation'
import { RollbackCommandForm } from './RollbackCommandForm'

export const LegalentityRollbackCommandForm = ({
  commandData,
  shouldSkipFrame,
  ...props
}: CommandDataFormProps<RollbackCommandData>) => {
  const { legalEntityId, tenantId } = useHook(
    'routing.general.useLegalEntityParams',
  )()

  const { data: frame } = useHook('fetchers.crm.useFetchRollbackFrame')(
    {
      tenantId,
      ownerId: legalEntityId,
      requestBody: {
        _type: 'RollbackCommandData',
        ...commandData,
      },
    },
    {
      enabled: shouldSkipFrame !== true,
    },
  )

  return (
    <RollbackCommandForm frame={frame} commandData={commandData} {...props} />
  )
}
